// 平滑滚动工具函数

export const smoothScrollTo = (elementId: string, offset: number = 80) => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

export const smoothScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// 初始化全局平滑滚动
export const initSmoothScroll = () => {
  // 为所有内部链接添加平滑滚动
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const link = target.closest('a[href^="#"]') as HTMLAnchorElement;
    
    if (link && link.hash) {
      e.preventDefault();
      const id = link.hash.substring(1);
      smoothScrollTo(id);
    }
  });

  // 添加 CSS 平滑滚动
  if (!document.getElementById('smooth-scroll-style')) {
    const style = document.createElement('style');
    style.id = 'smooth-scroll-style';
    style.textContent = `
      html {
        scroll-behavior: smooth;
      }
      
      @media (prefers-reduced-motion: reduce) {
        html {
          scroll-behavior: auto;
        }
      }
    `;
    document.head.appendChild(style);
  }
};

